import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";

const faqItems = [
  {
    question: 'Comment fonctionne BatiAssist ?',
    answer: 'BatiAssist combine un CRM batiment complet, 7 agents IA specialises et des assistants humains pour gerer ton entreprise. Les agents travaillent 24h/24 sur les taches repetitives, supervises par un assistant humain qui coordonne le tout.',
  },
  {
    question: 'Que font les agents IA ?',
    answer: 'Les 7 agents IA gerent : le standard telephonique, le service client (messagerie BatiAssist, SMS), les emails, le marketing sur les reseaux sociaux, le SEO et le blog, la prospection, et les taches administratives. Ils travaillent en permanence, 24h/24.',
  },
  {
    question: 'Que fait l\'assistant humain ?',
    answer: 'Ton assistant humain supervise les agents IA, verifie leur travail, gere les cas complexes, et communique directement avec toi via la messagerie BatiAssist integree. Il coordonne toutes les actions pour ton entreprise.',
  },
  {
    question: 'Combien coute BatiAssist ?',
    answer: 'Quatre formules : Start a 149€/mois (CRM + agents IA), Assistant Mi-Temps a 499€/mois (+assistant 20h), Assistant Dedie a 949€/mois (+assistant 40h), Croissance a 1499€/mois (+2 assistants et prospection). Frais de mise en place : 500€.',
  },
  {
    question: 'Y a-t-il un engagement ?',
    answer: 'Non, BatiAssist fonctionne sous forme d\'abonnement flexible sans engagement longue duree. Tu peux ajuster ou arreter a tout moment.',
  },
  {
    question: 'Quand le service commence-t-il ?',
    answer: 'Apres la validation de l\'inscription, une phase de preparation d\'environ 15 jours est necessaire pour configurer ton CRM, activer les agents IA et former ton assistant (si applicable).',
  },
  {
    question: 'Le CRM est-il adapte a mon metier ?',
    answer: 'Oui, BatiAssist a ete concu specifiquement pour les artisans du batiment : plombiers, electriciens, macons, piscinistes, carreleurs, menuisiers, peintres, couvreurs et artisans multiservices.',
  },
  {
    question: 'Mes donnees sont-elles protegees ?',
    answer: 'Oui, toutes les informations de ton entreprise sont traitees de maniere confidentielle avec des protocoles de securite stricts. Tes données restent ta propriété.',
  },
];

export default function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      ref={ref}
      className="py-16 sm:py-20 md:py-28 bg-slate-50"
      data-testid="faq-section"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-2 bg-ba-primary/10 text-ba-primary text-sm font-medium rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-rm-text mb-4 md:mb-6">
            Questions frequentes
          </h2>
          <p className="text-base md:text-lg text-rm-text-secondary">
            Tout ce que tu dois savoir sur BatiAssist
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-xl border border-slate-200 px-4 md:px-6 data-[state=open]:shadow-lg transition-all"
              >
                <AccordionTrigger className="text-left text-rm-text font-semibold py-4 md:py-5 hover:no-underline text-sm md:text-base">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-rm-text-secondary pb-4 md:pb-5 leading-relaxed text-sm md:text-base">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
